<template>
    <div id='menu_bar' class='menu-container'>
        <div class='item-headings'>
            <a class='item-heading-text' :class="{'item-heading-text-hover' :heading.hovering}" v-for='heading in headings' :key="heading.id" :href="(heading.type == 'CU') ? heading.custom_url : `/${heading.sef_url}`" @mouseover='hoverMenuItem(heading.id)' @click='openCategory($event, heading)'>
                {{heading.name}}
            </a>
        </div>

        <DesktopMenuPopoutTop :selected_heading='selected_heading' @selectedMenuItemListener='selectedMenuItem' @cancelHideListener="cancelHide" @hideMenuListener="hideMenu"/>
    </div>
</template>

<script>
import DesktopMenuPopoutTop from '@/ecom/components/navigation/header/menus/DesktopMenuPopoutTop.vue';

export default {
    components:{DesktopMenuPopoutTop},
    props: ['menu_items', 'headings', 'sub_headings'],
    data(){
        return{
            selected_heading: [],
            showTimer: null,
            hideTimer: null,
            hover_menu_delay: 200
        }
    },
    methods:{
        hoverMenuItem(heading_id){
            this.resetAllHeadingHover();

            this.selected_heading = this.menu_items.filter(x=>x.id == heading_id)[0];
            this.selected_heading.hovering = true;

            if(this.selected_heading.sub_headings.length != 0){
                this.showMenu();
            }
            else{
                this.selected_heading.hovering = false;
                this.hideMenu();
            }
        },
        resetAllHeadingHover(){
            for (let i = 0; i < this.menu_items.length; i++) {
                this.menu_items[i].hovering = false;
                
            }
        },
        openCategory(e, category){
            this.hideMenu();
            if(e.ctrlKey) {
                return;
            } else {
                e.preventDefault();
                let url = (category.type == 'CU') ? category.custom_url : `/${category.sef_url}`;
                this.$router.push(url);
            }
        },
        selectedMenuItem(e, category){
            this.hideMenu();
            if(e.ctrlKey) {
                return;
            } else {
                e.preventDefault();
                let url = (category.type == 'CU') ? category.custom_url : `/${category.sef_url}`;
                this.$router.push(url);
            }
        },
        handleMenuHover(){
            const isHover = e => e.parentElement.querySelector(':hover') === e;

            document.addEventListener('mousemove', (checkHover) => {
          
                const menu_bar = isHover(document.getElementById('menu_bar'));

                if (menu_bar !== checkHover.hovered) {
                    if(!menu_bar){
                        this.resetAllHeadingHover();
                        this.hideMenu();
                    }
                    checkHover.hovered = menu_bar;
                }
              
            });
        },
        showMenu(){
            clearTimeout(this.hideTimer);
            this.showTimer = setTimeout(() => {
                const menu = document.getElementById('menu');
                if(menu){
                    menu.classList.remove('hidden');      
                }         
                //document.getElementById('menu').classList.remove('hidden');
            }, this.hover_menu_delay);
        },
        hideMenu(){
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = setTimeout(() => {
                const menu = document.getElementById('menu');
                if(menu){
                    menu.classList.add('hidden');
                }
                //document.getElementById('menu').classList.add('hidden');
            }, this.hover_menu_delay - 100);
        },
        cancelHide() {
            clearTimeout(this.hideTimer);
        }
    },
    mounted(){
        this.handleMenuHover();
    }
}
</script>

<style lang="scss" scoped>
.menu-container{
    position: relative;
    display: flex;
    justify-content: center;
    height: var(--desktop-menu-container-height);
    align-items: center;

    @media(max-width: 1100px){
        display: none;
    }
}

.item-headings{
    display: flex;
    font-size: 0.78rem;
    height: 100%;
    cursor: pointer;
    // text-transform: uppercase;
}

.item-heading-text{
    align-content: center;   
    padding-left: 16px;
    padding-right: 16px;
    text-decoration: none;
    color: var(--primary-colour-2);
    // text-transform: uppercase;
    font-weight: 600;
    width: max-content;
    font-size: 1rem;
}

.item-heading-text:hover{
    background-color: white;
    border-radius: 8px;
}

.item-heading-text-hover{
    background-color: white;
    border-radius: 8px;
}

</style>